import {Component, Input} from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'environments/environment';
import { AdminService } from '../../services/admin';

@Component({
    selector: 'app-modal-content',
    template: `
    <div class="modal-header">
    <h5 class="modal-title text-center">   <font color="#0F7B79">{{nom_dr}}</font> </h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body" > 
<div class="">
<a href="{{urlfileIec_s}}" target="_blank" placement="bottom"  ngbTooltip="Manuel d'utilisation du site web du Centre Médico-Social du Ministère de l'Economie et des Finances.">
<img src="assets/img/cms/logo_cms.png" class="img-rounded img-responsive" alt="Rounded Image">
</a>
<h4 class="">
    <font color="#0F7B79">
     <figcaption>Nombres des visiteurs :  {{nombre_visiteur}}</figcaption>  
    <figcaption>Date de mise à ligne : 23 Mars 2020</figcaption></font> 
   
</h4>
</div>  

</div>

<div class="modal-footer" >
<div class="left-side">  
    <a href="{{urlfileIec_s}}"
     target="_blank "> MANUEL
    </a>
</div>
<div class="divider"></div>
<div class="right-side">
    <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close('Close click')">Fermer</button>
</div>
</div>
    `
})
export class NgbdModalContent_olde {
    @Input() name;
    nom_dr: string = "Statistique des visiteurs";
    urlfileIec__ = environment.urlfileIec;
    urlfileIec_ :any = "http://localhost/SiteCmsServeur/FileIEC/upload/file/iec/MANUEL_D_UTILISATION%20Site%20CMS.pdf";
     urlfileIec_s :any = "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/file/iec/manuel_cms.pdf";
  
    nombre_visiteur: any;
    constructor(public activeModal: NgbActiveModal,private adminService: AdminService) {
        this.adminService.getnombrevisiteur()
        .subscribe(data => {
          this.nombre_visiteur = data;
        }, err => {
    
        })
      }
    }
@Component({
    selector: 'app-modal-component',
    templateUrl: './modal.component.html'
})
export class NgbdModalComponent {
    constructor(private modalService: NgbModal) {}
    open() {
        const modalRef = this.modalService.open(NgbdModalContent_olde);
        modalRef.componentInstance.name = 'World';
    }
}
